/**
 * Message Role Types
 * Defines who authored a message in the conversation
 * Per AG-UI spec: "developer", "system", "assistant", "user", "tool"
 */

export const MESSAGE_ROLES = {
    /** Message from the human user */
    USER: 'user',
    /** Message from the AI assistant */
    ASSISTANT: 'assistant',
    /** System-level message (instructions, context) */
    SYSTEM: 'system',
    /** Developer-level message (prompts, instructions) */
    DEVELOPER: 'developer',
    /** Message from a tool/function */
    TOOL: 'tool'
};

/**
 * Roles that should be displayed in the chat UI
 */
export const DISPLAYABLE_ROLES = [
    MESSAGE_ROLES.USER,
    MESSAGE_ROLES.ASSISTANT
];

/**
 * Check if a role should be displayed in the chat
 * @param {string} role - Message role
 * @returns {boolean}
 */
export const isDisplayableRole = (role) => DISPLAYABLE_ROLES.includes(role);

/**
 * Get display name for a role (for UI labels)
 * @param {string} role - Message role
 * @returns {string}
 */
export const getRoleDisplayName = (role) => {
    const displayNames = {
        [MESSAGE_ROLES.USER]: 'You',
        [MESSAGE_ROLES.ASSISTANT]: 'Assistant',
        [MESSAGE_ROLES.SYSTEM]: 'System',
        [MESSAGE_ROLES.DEVELOPER]: 'Developer',
        [MESSAGE_ROLES.TOOL]: 'Tool'
    };
    return displayNames[role] || role;
};
